const SetStoreMapper = require('./atm/set-store-mapper');

module.exports = function (shopLocatorService, storePickerService, atm, $uibModalStack, $timeout, bwsNotificationService, $state, storePickerPanelService, settingsService, $window) {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            storeList: '=',
            atmEvent: '@?',
            stockcode: '@?',
            packSize: '@?',
            suburb: '=?',
            postcode: '=?'
        },
        link(scope) {
            scope.enableRedirect = false;
            scope.storePagesRedirectSettings = null;
            scope.storePicker = storePickerService;
            this._checkCartAvailability = false;

            scope.getStoreInfoUrlParams = function (store) {
                return shopLocatorService.generateUrlParamsForStoreInfos(store || scope.storePicker.store);
            };

            settingsService.getSettingValue('StoreLocator', 'CheckCartItemsAvailability').then(setting => {
                this._checkCartAvailability = setting;
            });

            settingsService.getFrontendSetting('StorePages', 'StorePagesRedirect')
				.then((res) => {
				scope.storePagesRedirectSettings = JSON.parse(res[0].Value);
				scope.enableRedirect = scope.storePagesRedirectSettings && scope.storePagesRedirectSettings.EnableRedirect;
            });

            scope.redirectStorePage = (store) => {
                if (scope.storePagesRedirectSettings && scope.storePagesRedirectSettings.EnableRedirect) {
                    const suburbYextFormat = store.Suburb.trim().replace(/\s+/g, '-');
					let storePathUrl = `${scope.storePagesRedirectSettings.RedirectBaseUrl}/${store.State}-${suburbYextFormat}-${store.StoreNo}`;
					storePathUrl = storePathUrl.toLocaleLowerCase();
					$window.location.assign(storePathUrl);
				}
            };

            scope.checkCartAvailability = () => this._checkCartAvailability;

            function completeStoreUpdate(store) {
                if ($uibModalStack.getTop()) {
                    $uibModalStack.dismissAll();
                }
                scope.storePicker.store = storePickerService.isDelivery() ? storePickerService.fulfilmentInfo.DeliveryDetails : storePickerService.fulfilmentInfo.ClickAndCollectDetails;
                scope.storePicker.setFulfilmentInfoInLocalStorage(storePickerService.fulfilmentInfo);
                const atmData = {
                    event: scope.atmEvent,
                    store,
                    fulfilmentInfo: storePickerService.fulfilmentInfo
                };
                // get the stockcode
                if (scope.stockcode) {
                    atmData.store.Stockcode = scope.stockcode;
                }

                atm.push(atmData, SetStoreMapper);
                $state.forceReload();
            }

            scope.setSelectedStore = function (store) {
                store.activeSetStore = true;

                if (storePickerService.isDelivery() && store.CanDeliverToLocation && $state.current.name !== 'shop.locator') {
                    scope.isSettingStore = true;

                    storePickerService.setDeliveryByStoreNo(store.StoreNo).then(() => {

                        if (scope.suburb) {
                            storePickerPanelService.setSuburbInLocalStorage({
                                SuburbName: scope.suburb,
                                PostCode: scope.postcode

                            });
                            bwsNotificationService.success(`Delivery to <strong>${scope.suburb}</strong> has been set.`);
                        }

                        completeStoreUpdate(store);

                    }).finally(function () {
                        scope.isSettingStore = false;
                        delete store.activeSetStore;
                    });
                } else {
                    storePickerService.setPickupByStoreNo(store.StoreNo).then(() => {
                        scope.isSettingStore = true;
                        storePickerPanelService.deliverySearch = {
                            SuburbName: store.Suburb,
                            FulfilmentStoreID: store.StoreNo
                        };

                        storePickerPanelService.setSuburbInLocalStorage({
                            SuburbName: store.Suburb,
                            PostCode: store.Postcode,
                            FulfilmentStoreID: store.StoreNo
                        });

                        bwsNotificationService.success(`You're browsing <strong>BWS ${store.Name}</strong>.`);
                        completeStoreUpdate(store);
                    }).finally(function () {
                        scope.isSettingStore = false;
                        delete store.activeSetStore;
                    });
                }
            };

            scope.itemAvailabilityMessage = function (store) {
                return storePickerService.findItemAvailabilityMessage(store, true);
            };
        },
        template: require('./shop-list-view-template.html')
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shoplocator/shop-list-view-directive.js
 **/